import { PRIORITY, type ValueRenderer } from "../types";

/** Returns the parsed object/array if `value` is a JSON string, else null. */
function parseJsonString(value: unknown): unknown {
  if (typeof value !== "string") return null;
  const trimmed = value.trim();
  if (!(trimmed.startsWith("{") || trimmed.startsWith("["))) return null;
  try {
    const parsed = JSON.parse(trimmed);
    return parsed && typeof parsed === "object" ? parsed : null;
  } catch {
    return null;
  }
}

export const CodeRenderer: ValueRenderer = {
  id: "code",
  match: value => (parseJsonString(value) != null ? { priority: PRIORITY.CONTENT_SNIFFED, confidence: "high" } : null),
  Component: ({ value }) => {
    const parsed = parseJsonString(value);
    return (
      <pre className="emboss-inner !bg-ds-neutral-100 dark:!bg-ds-neutral-800 mono-xs overflow-x-auto rounded-md p-3">
        {JSON.stringify(parsed, null, 2)}
      </pre>
    );
  },
};
